import type { Subtask, SubtaskKind } from './types'

export const subtaskKinds: SubtaskKind[] = ['Planejamento', 'Redação', 'Criação', 'Diagramação', 'Revisão']
export const subtaskKindOrder: Record<SubtaskKind, number> = { Planejamento: 0, Redação: 1, Criação: 2, Diagramação: 3, Revisão: 4 }

const requiredKinds: Record<SubtaskKind, SubtaskKind[]> = {
  Planejamento: [],
  Redação: [],
  Criação: ['Redação'],
  Diagramação: [],
  Revisão: ['Redação', 'Criação', 'Diagramação'],
}

function rootId(subtasks: Subtask[], subtask: Subtask) {
  const visited = new Set<string>()
  let current = subtask
  while (current.parentId && !visited.has(current.parentId)) {
    visited.add(current.id)
    const parent = subtasks.find(item => item.id === current.parentId)
    if (!parent) break
    current = parent
  }
  return current.id
}

export function linkedTasks(subtasks: Subtask[], subtask: Subtask) {
  const root = rootId(subtasks, subtask)
  return subtasks.filter(item => rootId(subtasks, item) === root)
}

export function dependencyState(subtasks: Subtask[], subtask: Subtask, targetKind: SubtaskKind = subtask.kind) {
  const group = linkedTasks(subtasks, subtask)
  const requirements = requiredKinds[targetKind]
  const blockers = group.filter(item => item.id !== subtask.id && requirements.includes(item.kind) && item.status !== 'Aprovada')
  return { blockers, satisfied: blockers.length === 0 }
}

export function completedDependents(subtasks: Subtask[], subtask: Subtask) {
  return linkedTasks(subtasks, subtask).filter(item =>
    item.id !== subtask.id && item.status === 'Aprovada' && requiredKinds[item.kind].includes(subtask.kind)
  )
}
